export default __webpack_public_path__ + "static/media/TrashIcon.aa4993e3.svg";